var _circle, _circle2;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
var SvgSoc2 = function SvgSoc2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0067D6",
    style: _defineProperty(_defineProperty({
      fill: "#0067d6"
    }, "fill", "color(display-p3 0 .4039 .8392)"), "fillOpacity", 1)
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#soc2_svg__a)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16.667,
    fill: "#0067D6",
    style: _defineProperty(_defineProperty({
      fill: "#0067d6"
    }, "fill", "color(display-p3 0 .4039 .8392)"), "fillOpacity", 1)
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16.667,
    fill: "url(#soc2_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.678 18.786 9.873 12.7h1.542l2.195 6.086h-1.355l-.445-1.295H9.47l-.446 1.295zm2.16-2.366h1.612l-.806-2.349zm4.279-3.72h1.303v6.086h-1.303zm7.457 3.891c-.248 1.475-1.191 2.332-2.649 2.332-1.8 0-2.93-1.363-2.93-3.172 0-1.808 1.13-3.188 2.93-3.188 1.398 0 2.358.823 2.623 2.228l-1.354.06c-.154-.762-.626-1.191-1.294-1.191-1.072 0-1.569.9-1.569 2.091 0 1.183.506 2.075 1.569 2.075.711 0 1.174-.463 1.311-1.286zm2.972-3.891c1.457 0 2.34.754 2.34 1.989 0 1.234-.883 1.997-2.34 1.997h-1.132v2.1h-1.302V12.7zm-1.132 2.889h1.055c.685 0 1.08-.309 1.08-.9 0-.592-.395-.892-1.08-.892h-1.055zm2.974 3.197 2.194-6.086h1.543l2.194 6.086h-1.354l-.446-1.295h-2.34l-.445 1.295zm2.16-2.366h1.611l-.805-2.349zm-18.419 9.3c.112.651.575 1.08 1.338 1.08.582 0 .977-.231.968-.677-.008-.446-.386-.703-1.337-.934-1.32-.318-2.169-.849-2.169-1.826 0-1.106.926-1.8 2.315-1.8 1.354 0 2.28.831 2.425 2.057l-1.303.069c-.068-.643-.514-1.046-1.157-1.046-.565 0-.968.291-.942.737.017.514.617.686 1.268.849 1.363.3 2.229.882 2.229 1.851 0 1.157-1.02 1.809-2.332 1.809-1.483 0-2.528-.823-2.614-2.109zm7.035 2.203c-1.851 0-2.957-1.217-2.957-3.172 0-1.971 1.106-3.188 2.957-3.188s2.966 1.217 2.966 3.188c0 1.955-1.115 3.172-2.966 3.172m-1.611-3.172c0 1.303.6 2.075 1.611 2.075 1.029 0 1.62-.772 1.62-2.075 0-1.311-.591-2.091-1.62-2.091-1.011 0-1.611.78-1.611 2.091m10.512.84c-.248 1.475-1.191 2.332-2.649 2.332-1.8 0-2.93-1.363-2.93-3.172 0-1.808 1.13-3.188 2.93-3.188 1.398 0 2.358.823 2.623 2.228l-1.354.06c-.154-.762-.626-1.191-1.294-1.191-1.072 0-1.569.9-1.569 2.091 0 1.183.506 2.075 1.569 2.075.711 0 1.174-.463 1.311-1.286zm.493-1.954c.103-1.2 1.012-2.074 2.358-2.074 1.277 0 2.194.78 2.194 1.851 0 .935-.746 1.475-1.577 1.955-.335.188-1.397.822-1.432 1.32h3.026v1.097h-4.611c0-1.783 1.003-2.597 2.245-3.3.617-.377 1.012-.695 1.012-1.089 0-.428-.352-.737-.857-.737-.549 0-.909.377-1.02 1.054z",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "soc2_svg__a",
    x1: 40,
    x2: -0.5,
    y1: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0F7",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B0F7",
    style: _defineProperty(_defineProperty({
      stopColor: "#01b0f7"
    }, "stopColor", "color(display-p3 .0039 .6902 .9686)"), "stopOpacity", 1)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "soc2_svg__b",
    x1: 36.667,
    x2: 2.917,
    y1: 36.667,
    y2: 3.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B0F7",
    style: _defineProperty(_defineProperty({
      stopColor: "#01b0f7"
    }, "stopColor", "color(display-p3 .0039 .6902 .9686)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B0F7",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }))));
};
export default SvgSoc2;